<template>
  <label :class="[style['blue-checkbox'], ...otherClasses]">
    <input type="checkbox" :checked="checked" @change.prevent="toggleCheck(index)" hidden>
    <span :class="style.checked" />
  </label>
</template>

<script>
import style from './scss/_checkbox.scss'
import { mapClassNameToArray } from 'Utilities'

export default {
  data: () => ({ style }),
  props: {
    checked: { type: Boolean, required: true },
    className: { type: String },
    toggleCheck: { type: Function },
    index: { type: Number }
  },
  computed: {
    otherClasses () {
      if (!this.className) { return [] }
      return mapClassNameToArray(this.className, style)
    }
  }
}
</script>
